<dx-popup [width]="950" [height]="740" [showTitle]="false" [(visible)]="currencyConversionPopupVisible"
    [dragEnabled]="false" [closeOnOutsideClick]="false">
    <div *dxTemplate="let data of 'content'">
        <h5 class="ap-green">Currency Conversion</h5>
        <dx-scroll-view>
            <form validationGroup="currencyConversion" #facilityForm="ngForm" (ngSubmit)="convertCurrency()" class="form-horizontal"
            autocomplete="off" showValidationSummary="true">
            <div class="row">
                <div class="col-4">
                    <div class="form-group mt-3">
                        <div class="form-group flex-fill">
                            <label for="sourceCurrency">Source Currency:</label>
                            <dx-select-box [readOnly]="true" name="sourceCurrency" id="sourceCurrency"
                                [items]="currencies" displayExpr="value" valueExpr="value"
                                [(value)]="facility.facilityDetail.currency">
                            </dx-select-box>
                        </div>
                    </div>
                    <div class="form-group mt-1">
                        <div class="form-group flex-fill">
                            <label for="exchangeRateYear" class="font-weight-bold">Exchange Rate Year:<span style="color: red"> *</span></label>
                            <dx-select-box name="exchangeRateYear" id="exchangeRateYear" [items]="exchangeYears"
                                [(value)]="exchangeRateYear">
                                <dx-validator>
                                    <dxi-validation-rule type="required" message="Exchange Rate Year is required"></dxi-validation-rule>
                                </dx-validator>
                            </dx-select-box>
                        </div>
                    </div>
                    <div class="form-group mt-3">
                        <div class="form-group flex-fill">
                            <label for="destinationCurrency" class="font-weight-bold">Destination Currency:<span style="color: red"> *</span></label>
                            <dx-select-box name="currency" id="currency" [items]="currencies" displayExpr="value"
                                valueExpr="value" [(value)]="destinationCurrency">
                                <dx-validator>
                                    <dxi-validation-rule type="required" message="Destination Currency is required"></dxi-validation-rule>
                                </dx-validator>
                            </dx-select-box>
                        </div>
                    </div>


                </div>
                <div class="col-4 addDeletePadding">
                    <div class="text-center pt-4">
                        <dx-button text="Convert ->" type="default" [useSubmitBehavior]="true"
                            (onClick)="convertCurrency()"></dx-button>
                    </div>
                </div>
                <div class="col-4">
                    <div class="mt-5 ml-4">
                        <label>Capital Investment: {{currencyConversion.capitalInvestment}}</label>
                    </div>
                    <div class="mt-3 ml-4">
                        <label>Gasifier Capital: {{currencyConversion.gasifierCapital}}</label>
                    </div>
                    <div class="mt-3 ml-4">
                        <label>ASU Capital: {{currencyConversion.asuCapital}}</label>
                    </div>
                    <div class="mt-3 ml-4">
                        <label>SMR Capital: {{currencyConversion.smrCapital}}</label>
                    </div>
                    <div class="mt-3 ml-4">
                        <label>Hydrogen/Other Capital: {{currencyConversion.hydrogenOtherCapital}} </label>
                    </div>
                    
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 text-center">
                    <div class="dx-fieldset">
                        <dx-validation-summary id="summary"></dx-validation-summary>
                    </div>
                    <dx-button [useSubmitBehavior]="false" text="Close"
                        class="ap-discard-button mr-1 mt-1 ml-2 px-5" (onClick)="close()">
                    </dx-button>
                </div>
            </div>
            </form>
        </dx-scroll-view>
    </div>
</dx-popup>

<dx-load-panel #dxLoadPanel shadingColor="rgba(0,0,0,0.4)" [visible]="isLoadPanelVisible" [showPane]="true"
    [shading]="true" [closeOnOutsideClick]="false">
</dx-load-panel>